class AnalyticsDelegate {
    setPeriod(period) {
        this.setState({ period });
    }

    setLimit(limit) {
        this.setState({ limit });
    }

    setTopPromotors(topPromotors) {
        this.setState({ topPromotors });
    }

    setInactivePromotors(inactivePromotors) {
        this.setState({ inactivePromotors });
    }
}

export default AnalyticsDelegate;
